import { render, staticRenderFns } from "./go.vue?vue&type=template&id=91c2bcaa&scoped=true&"
import script from "./go.vue?vue&type=script&lang=js&"
export * from "./go.vue?vue&type=script&lang=js&"
import style0 from "./go.vue?vue&type=style&index=0&id=91c2bcaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c2bcaa",
  null
  
)

export default component.exports